export const populateArray = <T, >(length: number, filling: T): Array<T> => (
  Array.from({ length }, () => filling)
);

export const range = (start: number, stop: number): Array<number> => (
  Array.from({ length: stop - start }, (_, key) => key + start)
);

export const sortCopy = <Item extends unknown>(array: Item[], compareFn?: (a: Item, b: Item) => number) => {
  const arrayCopy = [...array];
  if (compareFn) {
    arrayCopy.sort(compareFn);
  } else {
    arrayCopy.sort();
  }

  return arrayCopy;
}
